/* global axios */
import ApiClient from '../ApiClient';

class BrainAssistantsAPI extends ApiClient {
  constructor() {
    super('pipeline_brain/assistants', { accountScoped: true });
  }

  /**
   * List all Brain assistants for the account
   * @param {Number} accountId - Account ID
   * @returns {Promise}
   */
  list(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/pipeline_brain/assistants`);
  }

  /**
   * Get a single assistant
   * @param {Number} accountId - Account ID
   * @param {Number} id - Assistant ID
   * @returns {Promise}
   */
  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/${id}`);
  }

  /**
   * Create a new assistant
   * @param {Number} accountId - Account ID
   * @param {Object} data - Assistant data
   * @returns {Promise}
   */
  create(accountId, data) {
    return axios.post(`/api/v1/accounts/${accountId}/pipeline_brain/assistants`, {
      assistant: data,
    });
  }

  /**
   * Update an assistant
   * @param {Number} accountId - Account ID
   * @param {Number} id - Assistant ID
   * @param {Object} data - Assistant data
   * @returns {Promise}
   */
  update(accountId, id, data) {
    return axios.patch(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/${id}`, {
      assistant: data,
    });
  }

  /**
   * Delete an assistant
   * @param {Number} accountId - Account ID
   * @param {Number} id - Assistant ID
   * @returns {Promise}
   */
  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/${id}`);
  }

  documents(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/${id}/documents`);
  }

  getTools(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/${id}/tools`);
  }

  updateTools(accountId, id, enabledTools) {
    return axios.patch(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/${id}/update_tools`, {
      enabled_tools: enabledTools,
    });
  }

  syncAgents(accountId) {
    return axios.post(`/api/v1/accounts/${accountId}/pipeline_brain/assistants/sync_agents`);
  }
}

export default new BrainAssistantsAPI();
